<template>
  <div class="cc-tab-content">
    <div class="cctc-title">
      <div class="info">
        已有
        <span class="num">{{this.totalCount}}</span> 名用户完成展会登记
      </div>
      <div class="change" @click="change()" v-if="this.totalCount > 20">换一组</div>
    </div>
    <div class="cc-box_wrap">
      <div class="cc-box2" v-if="dataList.length">
        <div class="cc-list2" v-for="(item, index) in dataList" :key="index">
          <div class="cc-list2-t">
            <div class="logo">
              <img :src="item.avatarUrl" v-load="'oAvatar'"  v-if="item.avatarUrl">
              <img src="@/assets/img/empty.png" v-else/>
            </div>
            <div class="details" style="position: relative">
              <div class="line van-ellipsis">
                <span class="name">{{item.name || item.nickName}}</span>
                <span class="job">{{item.jobTitle}}</span>
                <span class="msg">已有{{item.inMember.sayUserCount}}人向他打招呼</span>
              </div>
              <div class="interest" style="position: relative">
                <div
                  class="category"
                  style="width: calc(100% - 60px);"
                  v-if="item.inMember.category"
                >
                  <div v-for="(mode,ind) in getCateList(item.inMember.category)" :key="ind" class="category_child">
                    <span>{{mode}}</span>
                  </div>
                </div>
                <span class="open-btn" v-if="item.id!=userInfo.id" @click.stop="goToSayHello(item.id)">打招呼</span> 
              </div>
              <div class="cc-list2-gx" v-if="item.inMember.lastSupplyDemand">
                <div>
                  <!-- <span>供需：</span> -->
                  <div class="l-span" v-if="item.inMember.lastSupplyDemand.content">
                    <span v-if="item.inMember.lastSupplyDemand.type" style="color:#f85b0f;">#{{item.inMember.lastSupplyDemand.type}}#</span>
                    {{item.inMember.lastSupplyDemand.content}}
                  </div>
                  <span class="r-span"></span>
                  <div class="sign_img" v-if="item.inMember.lastSupplyDemand.imgUrls">
                    <img
                      v-for="(imglist,index1) in item.inMember.lastSupplyDemand.imgUrls.split(';')"
                      :src="imglist"
                      :key="index1"
                      v-load="'oPic'"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-msg" v-else>暂无数据！</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import gql from 'graphql-tag'
export default {
  name: "major-list",
  data() {
    return {
      loading: false, //展商加载状态
      finished: false, //加载是否完成状态
      dataList: [], //供需列表
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0,
      queryMemberVisitor:'',
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    MemberGql(){
        return gql `query
                queryMemberVisitor($query: QueryInput!){
                    queryMemberVisitor(query:$query){
                       hasNextPage
                       pageIndex
                       totalCount
                       items{
                        avatarUrl
                        company
                        department
                        id
                        inMember(exhibitionId: "${this.exhibitionId}"){
                          category
                          createAt
                          exhibitionId
                          exhibitorId
                          id
                          lastSupplyDemand{
                            content
                            id
                            imgUrls
                            type
                          }
                          memberId
                          sayCount
                          sayUserCount
                          userId
                          userRole
                        }
                        introduction
                        jobTitle
                        name
                        nickName
                        phone
                        title
                        userId
                       }
                    }
                }`
      },
  },
  created(){
    this.init();
  },
  methods: {
    ...mapActions({
      LinkToSayHello:"linkTo/LinkToSayHello"
    }),
    //打招呼
    goToSayHello(id){
      if (this.userInfo.inMember.userRole.toUpperCase()=='VISITOR') { this.$Myapollo.unverifiedDialog(this,true,this.exhibitionId); return; }
      this.LinkToSayHello(id);
    },
    change(){
      this.pageIndex += 1;
      this.getdataList();
    },
    init(){
      this.getdataList();
    },
    getdataList(){
      let where = {
          "Equal":{
            "n":"exhibitionId",
            "v":this.exhibitionId
          },
      };
      let order = [];
      this.$apollo.addSmartQuery("queryMemberVisitor",{
        query:this.MemberGql,
        variables:{
          query:{
            page: this.pageIndex,
            size: this.pageSize,
            where:JSON.stringify(where),
            order:JSON.stringify(order),
          }
        },
        fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
        result(res){
          let data = JSON.parse(JSON.stringify(res));
          console.log(data,'行业人脉')
          if(data&&data.data.queryMemberVisitor){
            let currentList = data.data.queryMemberVisitor.items;
            this.dataList = [...currentList];
            this.totalCount = data.data.queryMemberVisitor.totalCount;
            if (!data.data.queryMemberVisitor.hasNextPage) {
              this.pageIndex = 0;
            }
          }
          this.$nextTick(()=>{
            $('html , body').animate({scrollTop: 1},0,()=>{
              $('html , body').stop().animate({scrollTop: 0},0);
            });
          })
        },
        error(error) {
          console.error(error,'error错误处理')
        }
      })
    },
    getCateList(str) {
      if(str){
        let newStr = str.replace(/>/g, "/")
        let option = newStr.split(';');
        let returnArr=[]
        option.forEach(e=>{
          let arr=e.split('/');
          returnArr.push(arr[arr.length-1])
        })
        // console.log(returnArr,'cate')
        return returnArr;
      }else{
        return []
      }
    },
    goCall(item){
       
    },
  },
};
</script>

<style scoped lang="scss">
.cc {
  &-tab {
    &-content {
      .cctc-title {
        // z-index: 99;
        // background: #f2f2f2;
        display: flex;
        padding: .3rem;
        align-items: center;
        justify-content: space-between;
        .info {
          font-size: .24rem;
          margin-right: 2px;
          max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #666;
          .num {
            color: #333;
          }
        }
        .change {
          color: #f85b0f;
          font-size: .24rem;
        }
        .btn {
          flex: 1;
          text-align: right;
          button {
            background-color: transparent;
          }
        }
      }
    }
  }
  &-box_wrap {
    padding-bottom: .6rem;
  }
  &-box2 {
    padding: 0 .3rem;
    .cc-list2 {
      padding: .2rem;
      margin-bottom: .2rem;
      background-color: #fff;
      border-radius: 5px;
      color: #666;
      &-t {
        margin-bottom: .28rem;
        display: flex;
        .logo {
          position: relative;
          flex-shrink: 0;
          width: .88rem;
          height: .88rem;
          margin-right: .14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .details {
          width: calc(100% - 1.02rem);
          .line {
            margin-bottom: .18rem;
            display: flex;
            align-items: flex-end;
            margin-top: -0.05rem;
            .name {
              color: #333;
              max-width: 60%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              display: inline-block;
              font-size: .26rem;
              margin-right: .1rem;
              font-weight: 600;
              transform: translateY(0.06rem);
              line-height: 1.5;
            }
            .job {
              max-width: 40%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              display: inline-block;
              font-size: .22rem;
              line-height: 1.5;
              transform: translateY(0.04rem);
            }
            .msg{
                position: absolute;
                right: 0;
                font-size: .18rem;
                color: #666;
            }
          }
          .interest {
            display: flex;
            flex-wrap: wrap;
            min-height: 24px;
            .category {
              display: flex;
              flex-wrap: wrap;
              min-height: .32rem;
              position: relative;
              top:3px;
            }
            .category_child {
              margin: 0 .1rem .1rem 0;
              display: flex;
              justify-items: center;
              align-items: center;
              text-align: center;
              height: .32rem;
              background: rgba(#f85b0f, 0.1);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              border-radius: 5px;
              padding: 0 0.11rem;
              span {
                font-size: .22rem;
                color: #f85b0f;
              }
            }
            .open-btn{
                font-size: .24rem;
                color: #ff5c00;
                width: 60px;
                height: 24px;
                background-color: #fff;
                border-radius: 12px;
                border: solid 1px #ff5c00;
                text-align: center;
                line-height: 24px;
                margin-bottom: 13px;
                position: absolute;
                right: 0;
            }
          }
          .info2 {
            font-size: .2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        //   /deep/ &-right {
        //     text-align: right;
        //     ._van-button {
        //       .van-button {
        //         width: 110px;
        //         height: 48px;
        //         background-color: #f85b0f;
        //         border-radius: 24px;
        //         margin-top: 23px;
        //       }
        //     }
        //   }
        }
        .txt {
          width: 2rem;
          padding-top: .16rem;
          text-align: right;
          font-size: .2rem;
          color: #bfbfbf;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-gx {
        position: relative;
        font-size: .26rem;
        color: #333;
        .l-span {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: inline-block;
          word-wrap: break-word;
          vertical-align: top;
          margin: 8px 0;
        }
        .l-span-s {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 99%;
          display: inline-block;
          word-wrap: break-word;
          vertical-align: top;
        }
        .r-span {
          color: #f85b0f;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      &-b {
        display: flex;
        .cclb {
          &-l {
            font-size: .2rem;
            width: 80%;
            padding-top: .13rem;
            .txt2 {
              color: #ffcc00;
              width: calc(100% - 1px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .txt3 {
              width: calc(100% - 1px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &-r {
            width: 20%;
            text-align: right;
            .btn {
              height: .48rem;
              line-height: .48rem;
              display: inline-block;
              padding: 0 .2rem;
              background-color: #f85b0f;
              border-radius: 4px;
            }
          }
        }
      }
    }
  }
}
.sign_img {
  display: flex;
  flex-wrap: wrap;
  img {
    width: 1.1rem;
    height: 1.1rem;
    margin-right: .1rem;
    display: block;
    margin-top: .1rem;
  }
}
</style>
